import React, { useRef } from "react";
import HorizontalPositionSettings from "fantastic/components/common/controls/background/HorizontalPositionSettings";
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import UrlSetting from "fantastic/components/common/controls/UrlSetting";
import ImageSizeSetting from "fantastic/components/common/controls/ImageSizeSetting";
import ToggleSetting from "fantastic/components/common/controls/ToggleSetting";
import BorderRadius from "fantastic/components/common/controls/border/BorderRadius";
import actions from "fantastic/actions";
import connectActions from "fantastic/lib/connectActions";
import settingable from "fantastic/components/hoc/settingable";
import { compose } from "redux";

const ImageSettings = (
  { selected,
    update,
    uploadImage,
    selectedNode: {
      src,
      href,
      alt,
      text_align,
      width,
      natural_width,
      fixed_width,
      css_padding_left,
      css_padding_right,
      css_border_radius,
      mobile_autosize
    }
  }) => {

  const onChange = (field) => {
    return (value) => {
      update(selected, { [field]: value });
    }
  };

  const positionSetting = {
    onChange: (_field, value) => onChange('text_align')(value),
    position: {
      field: "text_align",
      value: text_align
    }
  };

  const openWarehouse = event => {
    event.preventDefault();
    warehouseLoader.show(applySelectedImage);
  };

  const openWarehouseWithGeneration = event => {
    event.preventDefault();
    warehouseLoader.show(applySelectedImage, 'generation');
  };

  const applySelectedImage = image => {
    let attrs = { src: image.url };
    if (!alt || alt.length === 0) attrs.alt = image.name || '';
    update(selected, attrs);
  };
  const isImageSelected = typeof(src) !== 'undefined' && src.length > 0;

  const fileChangedHandler = (event) => {
    uploadImage(selected, event.target.files[0]);
  };
  const fileInput = useRef(null);
  const triggerUploadFile = () => {
    fileInput.current.click();
  };

  const borderRadiusParams = {
    displayInput: false,
    min: 0,
    max: 300,
    step: 1,
    value: css_border_radius,
    onChange: (value) => onChange('css_border_radius')(value)
  };

  return (
    <div>
      <SingleStringSetting
        value={src}
        onChange={onChange('src')}
        label={i18n.t('address')}
        placeholder="http://your_image_url"
      />
      <div className="form-group fantastic-image-settings__buttons">
        <button className="btn btn-form btn-with-icon" onClick={openWarehouse}>
          <i className="fa fa-cloud"></i>
          { i18n.t('select') }
        </button>
        <button className="btn btn-form btn-with-icon" onClick={triggerUploadFile}>
          <i className="fa fa-download"></i>
          { i18n.t('upload') }
        </button>
        <button className="btn btn-form btn-with-icon" onClick={openWarehouseWithGeneration}>
          <i className="fi fi-sparkles"></i>
          { i18n.t('generate_image') }
        </button>

        <input
          type="file"
          style={{ display: 'none' }}
          accept="image/jpeg,image/png,image/gif"
          onChange={fileChangedHandler}
          ref={fileInput}
        />
      </div>
      { isImageSelected &&
        <div className="form-group">
          <label>{ i18n.t('text_align') }</label>
          <div>
            <HorizontalPositionSettings {...positionSetting} />
          </div>
        </div>
      }
      <UrlSetting value={href} onChange={onChange('href')} />
      <SingleStringSetting value={alt} onChange={onChange('alt')} label="Alt" />
      <ImageSizeSetting
        paddingLeft={css_padding_left}
        paddingRight={css_padding_right}
        naturalWidth={natural_width}
        width={width}
        fixedWidth={fixed_width}
        selected={selected}
        mobileAutosize={mobile_autosize}
        update={update}
      />
      <BorderRadius {...borderRadiusParams} />
      {fixed_width &&
        <ToggleSetting
          onChange={(_field, value) => update(selected, { [_field]: value  }) }
          label={i18n.t('mobile_autosize')}
          field='mobile_autosize'
          value={mobile_autosize}
        />
      }
    </div>
  );
};

export default compose(
  settingable("padding", "visibility"),
  connectActions({
    uploadImage: actions.uploadImage
  })
)(ImageSettings);
